import React from 'react';

export const DAGGER = '†';
export const ASTRIK = '*';
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const TM = 'TM';

export const SYMBOL = {
  DAGGER: 'DAGGER',
  ASTRIK: 'ASTRIK',
  ONE: 'ONE',
  TWO: 'TWO',
  THREE: 'THREE',
  FOUR: 'FOUR',
};

export const DISCLAIMER_SYMBOL = {
  DAGGER: <sup>{DAGGER}</sup>,
  ASTRIK: <sup>{ASTRIK}</sup>,
  ONE: <sup>{ONE}</sup>,
  TWO: <sup>{TWO}</sup>,
  THREE: <sup>{THREE}</sup>,
  FOUR: <sup>{FOUR}</sup>,
  TM: <sup>{TM}</sup>,
};

